import { forwardRef } from "react";
import GenelDurumHelper from "../../helpers/GenelDurumHelper";
import { HesapSarkiSesKayitNotlarModel } from "../../models/businessModels/HesapSarkiSesKayitNotlarModel";
import PdfDisplayerWithCanvasView from "./pdfCanvas/PdfDisplayerWithCanvasView";

export interface IPdfDisplayerWithCanvasProps {
    icerikId: string,
    genelDurumHelper: GenelDurumHelper,
    initialImageIcerikId?: string | null,
    initialNotlar?: HesapSarkiSesKayitNotlarModel[],
    readonly?: boolean,
    getAudioSure?: () => number,
    playAudioAtSure?: (sure: number) => void,
}

export interface IPdfDisplayerWithCanvasHandle {
    hasChanges: () => boolean,
    undo: () => void,
    redo: () => void,
    exportLongPngBase64: () => Promise<string | null>,
    getNotlar: () => HesapSarkiSesKayitNotlarModel[],
}

const PdfDisplayerWithCanvas = forwardRef<IPdfDisplayerWithCanvasHandle, IPdfDisplayerWithCanvasProps>((props, ref) => {
    return <PdfDisplayerWithCanvasView {...props} canvasRef={ref} />;
});

PdfDisplayerWithCanvas.displayName = "PdfDisplayerWithCanvas";

export default PdfDisplayerWithCanvas;
